import NachWrapper from '../components/NachWrapper';
import DashboardFilterForm from './components/DashboardFilterForm';

function Dashboard() {
  return (
    <NachWrapper
      title="NACH Dashboard"
      className=" col-xs-12 col-sm-12 col-md-12"
      style={{ marginLeft: '15px' }}
    >
      <DashboardFilterForm onSubmit={() => Promise.resolve()} isLoading={false} />
    </NachWrapper>
  );
}

export default Dashboard;
